import { hasEmptyStringProperty } from "@/utils/string";
import { Stack } from "@mui/material";

import { FearuredRedeemPartnerCarousel } from "../RedeemPartner/FearuredRedeemPartnerCarousel";
import { KMVAppIncentiveSection } from "../RedeemPartner/KMVAppIncentiveSection";
import { PartnerDisplay } from "../RedeemPartner/PartnerDisplay";
import { PartnerDoubt } from "../RedeemPartner/PartnerDoubt";
import { RedeemPartnerStepsCarousel } from "../RedeemPartner/RedeemPartnerStepsCarousel";
import { InformativePartnerProps } from "./types";
import { FootballPartnerCarousel } from "./FootballPartnerCarousel";

export const InformativePartner: React.FC<InformativePartnerProps> = ({ informativePartner, footballCarouselItems }) => {
  return (
    <Stack bgcolor="#FFD100" mb={6}>
      <PartnerDisplay {...informativePartner} />
      <Stack mb={{ xs: "48px", md: "60px" }}>
        <FearuredRedeemPartnerCarousel cards={informativePartner.featuredProducts} isInformative={true} />
        <Stack paddingTop={"29px"}>
          {informativePartner.visibleFootballCaroussel && footballCarouselItems.length > 0 && (
            <FootballPartnerCarousel carouselName={""} items={footballCarouselItems} />
          )}
        </Stack>
      </Stack>

      <RedeemPartnerStepsCarousel cards={informativePartner?.howUseVoucher?.cards} title={informativePartner?.howUseVoucher?.title} />
      {!hasEmptyStringProperty(informativePartner?.kmvAppIncentiveSection) && (
        <KMVAppIncentiveSection {...informativePartner?.kmvAppIncentiveSection} />
      )}
      <PartnerDoubt listQuestionsAnswer={informativePartner?.partnerFaq?.questionsAndAnswerList} {...informativePartner.partnerFaq} />
    </Stack>
  );
};
